"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationType = void 0;
var NavigationType;
(function (NavigationType) {
    NavigationType["TYPE_NAVIGATE"] = "TYPE_NAVIGATE";
    NavigationType["TYPE_RELOAD"] = "TYPE_RELOAD";
    NavigationType["TYPE_BACK_FORWARD"] = "TYPE_BACK_FORWARD";
    NavigationType["TYPE_RESERVED"] = "TYPE_RESERVED";
    NavigationType["OUTDATED_SCHEMA"] = "OUTDATED_SCHEMA";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));
//# sourceMappingURL=NavigationTypeEnum.js.map